import cn from "classnames";
import { FormattedMessage } from "react-intl";
import { useAppDispatch, useAppSelector } from "../../../../store";
import { ChatMessageType, ProcessedMessageMode } from "../../../../types/Chat";
import { selectChatUserId, setProcessedMessage } from "../../../../store/chat/chatSlice";

import { renderDangerHTML } from "../RenderDangerHtml/RenderDangerHtml";
import './ChatFormProcessedMessage.scss';

type ChatFormProcessedMessageProps = {
    message: ChatMessageType;
    mode: ProcessedMessageMode;
};

export const ChatFormProcessedMessage = ({ message, mode }: ChatFormProcessedMessageProps) => {
    const dispatch = useAppDispatch();
    const userId = useAppSelector(selectChatUserId);

    const handleClose = () => {
        dispatch(setProcessedMessage({ mode: null, message: null }));
    };

    const isReplying = mode === ProcessedMessageMode.IS_REPLYING;

    return (
        <div className={cn("chat-processed", {isReplying})}>
            <div className="chat-processed-title">
                {isReplying ? (
                    <>
                        <FormattedMessage id="chat.dropdown.option.reply" defaultMessage="Reply" />
                        <span>{message?.owner_id === userId ? message?.owner?.name : 'Support'}</span>
                    </>
                ) : null}
            </div>
            {renderDangerHTML(message?.body, 'chat-processed-text')}
            <div className="chat-processed-close" onClick={handleClose}><i className="fi fi-rr-cross"/></div>
        </div>
    )
}